import { useState } from "react";
import { WorkOrder } from "@/services/backend/rlt/work-orders/types/work-order";
import {
  UpdateExecutingBranchRequest,
  useRltWorkOrderUpdateExecutingBranchMutation,
} from "@/services/backend/rlt/work-orders/api/work-order-api";
import { useDebouncedMutation } from "@/shared/lib/debounce/debounce";
import { useFieldErrors } from "@/shared/lib/errors/err-validation-failed-context";
import { useListBranchQuery } from "@/services/backend/company/api/branch";
import { Label } from "@/shared/components/ui/label";
import t from "@/lang/lang";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/shared/components/ui/select";
import { FieldErrors } from "@/shared/components/field/field";

export function WorkOrderExecutingBranchSelect({
  workOrder,
  disabled = false,
}: {
  workOrder: WorkOrder;
  disabled?: boolean;
}) {
  const [request, setRequest] = useState<UpdateExecutingBranchRequest>({
    id: workOrder.id,
    executingBranchId: workOrder.executingBranchId,
  });
  const mutation = useRltWorkOrderUpdateExecutingBranchMutation();
  useDebouncedMutation(
    request,
    setRequest,
    mutation,
    {
      id: workOrder.id,
      executingBranchId: workOrder.executingBranchId,
    },
    { delay: 0 },
  );

  const { errors, invalid, reset } = useFieldErrors("executingBranchId");

  const { data: list } = useListBranchQuery({
    company: { active: true, values: [workOrder.companyId] },
  });
  const branches = list?.branches ?? [];

  return (
    <div className="grid gap-1.5">
      <Label>{t("Ausführende Niederlassung")}</Label>
      <Select
        value={request.executingBranchId}
        onValueChange={(executingBranchId) => {
          reset();
          setRequest({ ...request, executingBranchId });
        }}
        disabled={disabled}
      >
        <SelectTrigger className="w-full" aria-invalid={invalid || undefined}>
          <SelectValue placeholder={t("Auswählen...")} />
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>
            <SelectLabel>{t("Niederlassung")}</SelectLabel>
            {branches.map((branch) => (
              <SelectItem key={branch.id} value={branch.id}>
                {branch.name}
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
      <FieldErrors errors={errors} />
    </div>
  );
}
